/**
 * Import alias mapping for CSV/HRIS auto-detection.
 * Generated from the field pack plan — this is the single source of truth.
 * Keys are our universal field IDs, values are case-insensitive aliases.
 */
export const PERSON_FIELD_ALIASES: Record<string, string[]> = {
  // Base pack
  personId: ['personid', 'person_id', 'employeeid', 'employee_id', 'id', 'worker_id', 'workerid', 'emp_id', 'empid', 'associate_oid', 'employee_no', 'employeeno', 'employee_code', 'staff_id', 'associate_id', 'worker_number', 'uniqueid', 'unique_id'],
  employeeNumber: ['employee_number', 'employeenumber', 'emp_number', 'badge_number', 'payroll_id'],
  name: ['name', 'full_name', 'fullname', 'display_name', 'displayname', 'employee_name'],
  firstName: ['first_name', 'firstname', 'given_name', 'givenname', 'forename'],
  lastName: ['last_name', 'lastname', 'surname', 'family_name', 'familyname'],
  preferredName: ['preferred_name', 'preferredname', 'nickname', 'preferred_first_name', 'goes_by'],
  title: ['title', 'job_title', 'jobtitle', 'position', 'position_title', 'positiontitle', 'role', 'designation', 'job_role', 'jobrole', 'position_name'],
  email: ['email', 'work_email', 'workemail', 'email_address', 'mail', 'business_email', 'email_id', 'official_email', 'work_mail'],
  phone: ['phone', 'work_phone', 'workphone', 'business_phone', 'telephone', 'mobile', 'cell'],
  department: ['department', 'dept', 'team', 'org_unit', 'orgunit', 'business_unit', 'department_name', 'dept_name', 'team_name'],
  reportsTo: ['reports_to', 'reportsto', 'manager', 'manager_id', 'managerid', 'supervisor', 'supervisor_id', 'direct_manager', 'line_manager', 'line_manager_id', 'reporting_manager'],
  secondaryReportsTo: [
    'secondary_reports_to',
    'secondaryreportsto',
    'secondary_manager',
    'secondary_manager_id',
    'secondary_supervisor',
    'secondary_supervisor_id',
    'dotted_line_manager',
    'dotted_line_manager_id',
    'functional_manager',
    'functional_manager_id',
    'alternate_manager',
    'alternate_manager_id',
  ],
  photoRef: [
    'photoRef',
    'photo_ref',
    'photoref',
    'photo',
    'photo_url',
    'photourl',
    'image',
    'image_ref',
    'imageref',
    'image_link',
    'imagelink',
    'avatar',
    'avatar_ref',
    'avatarref',
    'avatar_url',
    'avatarurl',
    'avatar_link',
    'avatarlink',
    'picture',
    'picture_ref',
    'pictureref',
    'picture_url',
    'pictureurl',
    'picture_link',
    'picturelink',
    'pic_url',
    'profile_photo',
    'profilephoto',
    'profile_photo_url',
    'profilephotourl',
    'profile_picture',
    'profilepicture',
    'profile_pic',
    'profilepic',
    'profile_image',
    'profileimage',
    'profile_image_url',
    'profileimageurl',
    'image_url',
    'imageurl',
    'headshot',
    'headshot_url',
    'headshoturl',
    'headshot_link',
    'headshotlink',
  ],
  joinDate: ['join_date', 'joindate', 'hire_date', 'hiredate', 'start_date', 'startdate', 'original_hire_date', 'date_of_hire', 'date_of_join', 'dateofjoin', 'date_of_joining', 'dateofjoining', 'joining_date', 'joiningdate', 'doj'],
  departureDate: ['departure_date', 'departuredate', 'termination_date', 'terminationdate', 'end_date', 'enddate', 'last_day'],
  status: ['status', 'employment_status', 'employmentstatus', 'employee_status', 'active', 'worker_status'],
  notes: ['notes', 'comments', 'remarks', 'memo'],

  // Organization pack
  division: ['division', 'div'],
  businessUnit: ['business_unit', 'businessunit', 'bu'],
  subDepartment: ['sub_department', 'subdepartment', 'sub_dept', 'section', 'unit'],
  costCenter: ['cost_center', 'costcenter', 'cost_centre', 'costcentre', 'cc'],
  location: ['location', 'office', 'work_location', 'worklocation', 'site', 'city', 'office_location'],
  building: ['building', 'building_name', 'facility'],
  floor: ['floor', 'floor_number', 'level'],
  region: ['region', 'area', 'geographic_region', 'geo'],
  country: ['country', 'country_code', 'nation'],
  timezone: ['timezone', 'time_zone', 'tz'],
  workMode: ['work_mode', 'workmode', 'work_arrangement', 'remote_status', 'work_type', 'hybrid_status'],
  legalEntity: ['legal_entity', 'legalentity', 'company', 'employer', 'subsidiary'],

  // Role pack
  positionId: ['position_id', 'positionid', 'role_id', 'roleid', 'position_number', 'position_no', 'positionnumber'],
  jobCode: ['job_code', 'jobcode', 'jc', 'job_class', 'job_classification', 'job_class_code'],
  positionCode: ['position_code', 'positioncode'],
  jobFamily: ['job_family', 'jobfamily', 'job_group', 'role_family'],
  jobLevel: ['job_level', 'joblevel', 'grade', 'level', 'career_level', 'band_level'],
  managementLevel: ['management_level', 'managementlevel', 'mgmt_level', 'leader_level'],
  employmentType: ['employment_type', 'employmenttype', 'emp_type', 'contract_type'],
  fte: ['fte', 'full_time_equivalent', 'scheduled_hours_ratio'],
  workerType: ['worker_type', 'workertype', 'emp_class', 'employee_class', 'worker_category'],
  regularTemporary: ['regular_temporary', 'regulartemporary', 'reg_temp', 'permanent_temp'],
  flsaStatus: ['flsa_status', 'flsastatus', 'flsa', 'exempt_status', 'exempt_nonexempt'],
  unstaffed: ['unstaffed', 'vacant', 'is_vacant', 'vacancy'],
  isFuture: ['is_future', 'isfuture', 'future', 'planned'],

  // Talent pack
  performance: ['performance', 'performance_rating', 'performancerating', 'perf_rating', 'annual_rating'],
  potential: ['potential', 'growth_potential', 'talent_potential', 'potential_rating', 'potentialrating'],
  nineBoxPlacement: ['nine_box', 'ninebox', '9box', '9_box', 'talent_matrix', 'nine_box_placement'],
  readiness: ['readiness', 'succession_readiness', 'ready_level', 'readiness_level', 'successor_readiness'],
  flightRisk: ['flight_risk', 'flightrisk', 'attrition_risk', 'retention_risk', 'risk_of_loss', 'turnover_risk'],
  impactOfLoss: ['impact_of_loss', 'impactofloss', 'loss_impact', 'criticality'],
  futureLeader: ['future_leader', 'futureleader', 'high_potential', 'hipo', 'hi_po', 'leadership_pipeline'],
  talentPool: ['talent_pool', 'talentpool', 'pipeline', 'development_pool'],
  calibrationRating: ['calibration_rating', 'calibrationrating', 'calibration', 'calibrated_rating'],
  lastReviewDate: ['last_review_date', 'lastreviewdate', 'review_date', 'last_appraisal_date'],
  nextReviewDate: ['next_review_date', 'nextreviewdate', 'next_appraisal_date'],
  overallRating: ['overall_rating', 'overallrating', 'final_rating', 'composite_rating'],
  talentEngagementScore: ['talent_engagement_score', 'talentengagementscore'],

  // Compensation pack
  salary: ['salary', 'base_salary', 'basesalary', 'base_pay', 'basepay', 'annual_salary', 'compensation'],
  currency: ['currency', 'currency_code', 'pay_currency', 'salary_currency'],
  payFrequency: ['pay_frequency', 'payfrequency', 'pay_period', 'payment_frequency'],
  band: ['band', 'pay_band', 'payband', 'pay_grade', 'paygrade', 'comp_band', 'salary_band'],
  payRangeMin: ['pay_range_min', 'payrangemin', 'salary_min', 'range_min', 'min_salary', 'band_min'],
  payRangeMid: ['pay_range_mid', 'payrangemid', 'salary_mid', 'range_mid', 'midpoint', 'band_mid'],
  payRangeMax: ['pay_range_max', 'payrangemax', 'salary_max', 'range_max', 'max_salary', 'band_max'],
  compaRatio: ['compa_ratio', 'comparatio', 'comp_ratio', 'salary_ratio', 'range_penetration'],
  bonusTarget: ['bonus_target', 'bonustarget', 'target_bonus', 'bonus_pct', 'incentive_target'],
  totalComp: ['total_comp', 'totalcomp', 'total_compensation', 'total_rewards', 'tc', 'tdc'],
  annualCost: ['annual_cost', 'annualcost', 'total_cost', 'fully_loaded_cost', 'employment_cost'],
  lastCompChangeDate: ['last_comp_change_date', 'lastcompchangedate', 'last_salary_change', 'last_pay_change'],

  // Skills pack
  skills: ['skills', 'skill_set', 'skillset', 'competencies_skills'],
  primarySkill: ['primary_skill', 'primaryskill', 'top_skill', 'core_skill', 'main_skill'],
  certifications: ['certifications', 'certificates', 'credentials', 'professional_certifications'],
  languages: ['languages', 'language_skills', 'spoken_languages'],
  educationLevel: ['education_level', 'educationlevel', 'education', 'degree', 'highest_degree'],
  educationField: ['education_field', 'educationfield', 'field_of_study', 'major', 'degree_field'],
  competencies: ['competencies', 'core_competencies', 'competency_list'],
  technicalSkills: ['technical_skills', 'technicalskills', 'tech_skills', 'hard_skills'],
  leadershipSkills: ['leadership_skills', 'leadershipskills', 'leadership_competencies'],
  trainingCompleted: ['training_completed', 'trainingcompleted', 'courses_completed', 'training_hours'],
  certExpiryDate: ['cert_expiry_date', 'certexpirydate', 'certification_expiry', 'cert_renewal_date'],

  // Workforce pack
  tenure: ['tenure', 'years_of_service', 'service_years', 'yos', 'seniority'],
  retirementDate: ['retirement_date', 'retirementdate', 'expected_retirement', 'planned_retirement'],
  contractEndDate: ['contract_end_date', 'contractenddate', 'contract_expiry', 'end_of_contract'],
  probationEndDate: ['probation_end_date', 'probationenddate', 'probation_expiry', 'probation_end'],
  lastPromotionDate: ['last_promotion_date', 'lastpromotiondate', 'promotion_date', 'last_promotion'],
  promotionCount: ['promotion_count', 'promotioncount', 'total_promotions', 'num_promotions'],
  timeInRole: ['time_in_role', 'timeinrole', 'role_tenure', 'position_tenure', 'time_in_position'],
  previousRole: ['previous_role', 'previousrole', 'prior_role', 'last_role', 'former_title'],
  previousDepartment: ['previous_department', 'previousdepartment', 'prior_department', 'last_department'],
  mobilityPreference: ['mobility_preference', 'mobilitypreference', 'relocation', 'willing_to_relocate'],
  careerInterest: ['career_interest', 'careerinterest', 'career_aspiration', 'development_interest'],
  targetRole: ['target_role', 'targetrole', 'aspired_role', 'next_role', 'career_goal'],
  noticePeriod: ['notice_period', 'noticeperiod', 'notice_length', 'resignation_notice'],
  visaStatus: ['visa_status', 'visastatus', 'work_authorization', 'visa_type'],
  visaExpiry: ['visa_expiry', 'visaexpiry', 'visa_end_date', 'work_auth_expiry'],

  // Succession pack
  keyPosition: ['key_position', 'keyposition', 'critical_position', 'succession_critical'],
  successorCount: ['successor_count', 'successorcount', 'named_successors', 'pipeline_depth'],
  readyNowSuccessor: ['ready_now_successor', 'readynowsuccessor', 'ready_now', 'immediate_successor'],
  successionRisk: ['succession_risk', 'successionrisk', 'bench_risk', 'coverage_risk'],
  benchStrength: ['bench_strength', 'benchstrength', 'pipeline_strength', 'successor_strength'],
  developmentPlan: ['development_plan', 'developmentplan', 'idp', 'individual_development_plan'],
  mentor: ['mentor', 'mentor_name', 'assigned_mentor'],
  coach: ['coach', 'coach_name', 'assigned_coach', 'executive_coach'],
  careerPath: ['career_path', 'careerpath', 'career_track', 'development_track'],
  yearsToReadiness: ['years_to_readiness', 'yearstoreadiness', 'readiness_timeline', 'time_to_ready'],
  criticalExperience: ['critical_experience', 'criticalexperience', 'key_experience', 'development_experience'],
  retentionStrategy: ['retention_strategy', 'retentionstrategy', 'retention_plan', 'retention_action'],

  // Demographics pack
  gender: ['gender', 'sex', 'gender_identity'],
  pronouns: ['pronouns', 'preferred_pronouns', 'gender_pronouns'],
  ethnicity: ['ethnicity', 'race', 'race_ethnicity', 'ethnic_group', 'eeo_race'],
  nationality: ['nationality', 'citizenship', 'country_of_citizenship'],
  dateOfBirth: ['date_of_birth', 'dateofbirth', 'dob', 'birth_date', 'birthdate'],
  ageGroup: ['age_group', 'agegroup', 'age_band', 'age_range', 'generation_band'],
  generation: ['generation', 'gen', 'generational_cohort'],
  veteranStatus: ['veteran_status', 'veteranstatus', 'military_status', 'veteran'],
  disabilityStatus: ['disability_status', 'disabilitystatus', 'disability', 'accommodation_status'],
  maritalStatus: ['marital_status', 'maritalstatus', 'marriage_status'],
  diversityFlags: ['diversity_flags', 'diversityflags', 'diversity_categories', 'eeo_flags'],

  // Engagement pack
  engagementScore: ['engagement_score', 'engagementscore', 'engagement', 'esat'],
  eNPS: ['enps', 'e_nps', 'employee_nps', 'employee_net_promoter'],
  lastSurveyDate: ['last_survey_date', 'lastsurveydate', 'survey_date', 'last_pulse_date'],
  satisfactionScore: ['satisfaction_score', 'satisfactionscore', 'satisfaction', 'job_satisfaction'],
  managerRating: ['manager_rating', 'managerrating', 'manager_effectiveness', 'mgr_rating'],
  absenteeismRate: ['absenteeism_rate', 'absenteeismrate', 'absence_rate', 'sick_days_rate'],
  voluntaryTurnoverRisk: ['voluntary_turnover_risk', 'voluntaryturnoverrisk', 'vol_turnover_risk', 'quit_risk'],
  lastOneOnOneDate: ['last_one_on_one_date', 'lastoneononedate', 'last_1_on_1', 'last_check_in'],
  recognitionsReceived: ['recognitions_received', 'recognitionsreceived', 'kudos_received', 'awards_received'],
  recognitionsGiven: ['recognitions_given', 'recognitionsgiven', 'kudos_given', 'peer_recognitions'],
};

/**
 * Build a reverse lookup: alias (lowercased) → universal field ID.
 */
export function buildAliasLookup(): Map<string, string> {
  const lookup = new Map<string, string>();
  for (const [fieldId, aliases] of Object.entries(PERSON_FIELD_ALIASES)) {
    lookup.set(fieldId.toLowerCase(), fieldId);
    for (const alias of aliases) {
      lookup.set(alias.toLowerCase(), fieldId);
    }
  }
  return lookup;
}

/**
 * Singleton cached alias lookup — built once on first access.
 */
let _cachedLookup: Map<string, string> | null = null;

export function getAliasLookup(): Map<string, string> {
  if (!_cachedLookup) {
    _cachedLookup = buildAliasLookup();
  }
  return _cachedLookup;
}

/**
 * Normalize any field name variant to its canonical field pack ID.
 * Returns the input unchanged if no alias match is found.
 *
 * Strategy:
 * 1. Lowercase and look up in alias map
 * 2. Strip all non-alphanumeric chars and retry ("Pay Band" → "payband" → matches)
 */
export function normalizeFieldId(raw: string): string {
  const lookup = getAliasLookup();
  const lower = raw.toLowerCase();

  const direct = lookup.get(lower);
  if (direct) return direct;

  const stripped = lower.replace(/[^a-z0-9]/g, '');
  if (stripped !== lower) {
    const strippedMatch = lookup.get(stripped);
    if (strippedMatch) return strippedMatch;
  }

  return raw;
}

/**
 * Convert PERSON_FIELD_ALIASES to the format expected by OrgChartProfile.fieldAliases.
 */
export function toProfileFieldAliases(): Record<string, string[]> {
  return { ...PERSON_FIELD_ALIASES };
}
